import { Icon } from '@iconify/react';
import ReactApexChart from 'react-apexcharts';
import trendingUpFill from '@iconify/icons-eva/trending-up-fill';
import trendingDownFill from '@iconify/icons-eva/trending-down-fill';
// material
import { alpha, useTheme, experimentalStyled as styled } from '@material-ui/core/styles';
import { Box, Card, Typography, Stack, Grid, Paper } from '@material-ui/core';
// utils
import { fNumber, fPercent } from '../../../utils/formatNumber';

// ----------------------------------------------------------------------

const IconWrapperStyle = styled('div')(({ theme }) => ({
  width: 24,
  height: 24,
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  justifyContent: 'center',
  color: theme.palette.success.main,
  backgroundColor: alpha(theme.palette.success.main, 0.16)
}));

const CHART_DATA = [
  // {
  //   venue: 'Bharat Mandapam in New Delhi,India',
  //   date: '15 Oct 2024 - 18 Oct 2024',
  //   eventname:'India Mobile Congress 2024',
  // },
  {
    venue: 'Kochi, Kerala',
    eventname:'Invest Kerala Global Summit 2025',
    date: '21 Feb, 2025 - 22 Feb, 2025'
  },
  {
    venue: 'New Delhi, India',
    eventname:'INDIASOFT 2025',
    date: '19 Mar 2025 - 21 Mar 2025'
  },
  
//   {
//     venue: 'Boston, United States',
//     eventname:'SCDM (Society of Clinical Data Management)',
//     date: '11 Nov, 2024 - 14 Nov, 2024'
//   }
];

// ----------------------------------------------------------------------

export default function UpcomingEventsCard() {
  const theme = useTheme();

  return (
    <Grid container spacing={3}>
      {CHART_DATA.map((data, index) => (
        <Grid item xs={12} sm={6} md={6} key={index}>
          <Paper sx={{ 
            display: 'flex', 
            flexDirection: 'column', 
            justifyContent: 'space-between', // Ensures spacing is distributed evenly, placing the stack at the bottom
            p: 3,
            borderRadius:'0px',
            mt: 2,
            border:'1px solid #868686',
            height: '100%' // Makes sure all cards have the same height
          }}>
            <Typography sx={{
                fontSize: '24px',
                fontWeight: 460,
                mb: 2, // Margin between event name and the stack
                color: '#000049',
                lineHeight:1.2,
                fontFamily:'"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
              }}>{data.eventname}</Typography>
            <Stack direction="column" spacing={1}>
              <Typography sx={{
                fontSize:'20px',
                color: '#000049',
                fontWeight:660,
                fontFamily:'"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
              }}>{data.date}</Typography>
              <Typography sx={{
                fontSize:'17px',
                color: '#000049',
                fontFamily:'"Gellix",system-ui,-apple-system,"Segoe UI",Roboto,"Helvetica Neue","Noto Sans","Liberation Sans",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji"',
              }} variant="subtitle2">
                {data.venue}
              </Typography>
            </Stack>
          </Paper>
        </Grid>
      ))}
    </Grid>
  );
}